import CalendarScreenPortraitView from "./CalendarScreenPortraitView"
export default CalendarScreenPortraitView
